import { InvestmentServiceURL, TaskmgmtServiceURL } from "../config/config";
import { postApiCall } from "./apiHelper";
import { ServiceName } from "../constants";
import { GridFilterModel, GridLogicOperator } from "@mui/x-data-grid-pro";
import { AnyAaaaRecord } from "dns";
import UserRoleMapDashboard from "../components/settings/user-role-map/UserRoleMapDashboard";
import { LazyLoadEventModel } from "../all_Interfaces";



export class DashboardService {
  getUserRoleMap(paginationModel: { page: number; pageSize: number }, filterModel:any) {
    var userRoleFilterArr: any[] = [];
    userRoleFilterArr = filterModel?.items?.map((userRoleFilter: any) => {
      if (userRoleFilter?.value != undefined) {
        return {
          filterConditionalOperator:filterModel.logicOperator,
          identity: userRoleFilter?.field,
          matchMode: userRoleFilter?.operator,
          value: userRoleFilter?.value,
        };
      }
    });
    var url = `${TaskmgmtServiceURL}` + "/userrolemaps/GetAllUserRoleDashboard";
    var payload: LazyLoadEventModel = {
        filters: userRoleFilterArr,
        first: paginationModel.page * paginationModel.pageSize,
        filterConditionalOperator: filterModel.logicOperator,
        globalFilter: null,
        rows: paginationModel.pageSize,
        sortOrder: 1
      };

      if(payload.filters.length == 0){
        payload = {...payload,filterConditionalOperator:GridLogicOperator.And}
      }

    const response = postApiCall(url, payload, ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => data);
    return response;
  }

  getUserRoleMapToBeArchived(paginationModel: { page: number; pageSize: number }, filterModel:any) {
    var userRoleFilterArr: any[] = [];
    userRoleFilterArr = filterModel?.items?.map((userRoleFilter: any) => {
      if (userRoleFilter?.value != undefined) {
        return {
          identity: userRoleFilter?.field,
          matchMode: userRoleFilter?.operator,
          value: userRoleFilter?.value,
        };
      }
    });
    var url = `${TaskmgmtServiceURL}` + "/userrolemaps/GetAllUserRoleToBeArchived";
    var payload: LazyLoadEventModel = {
        filters: userRoleFilterArr,
        first: paginationModel.page * paginationModel.pageSize,
        filterConditionalOperator: filterModel.logicOperator,
        globalFilter: null,
        rows: paginationModel.pageSize,
        sortOrder: 1
      };


      if(payload.filters.length == 0){
        payload = {...payload,filterConditionalOperator:GridLogicOperator.And}
      }

    const response = postApiCall(url, payload, ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => data);
    return response;
  }

  getAllInvestments(payload:LazyLoadEventModel) {
    var url = `${InvestmentServiceURL}` + "/investments/GetAllInvestmentsView";
      console.log(payload);
    const response = postApiCall(url, payload, ServiceName.INVESTMENTSERVICE).then((data: any) => data);
    return response;
  }
}

